import React from 'react';
import { Card } from '../components/ui/card';
import { Award, GraduationCap, Users, Heart } from 'lucide-react';
import SEO from '../components/SEO';

const About = () => {
  return (
    <main className="pt-24 bg-[#FDFDFB]">
      <SEO 
        title="About - Meet Our Provider"
        description="Learn about Dr. Shaquita Starks, PhD, PMHNP-BC, FAAN - Board-Certified Psychiatric Mental Health Nurse Practitioner providing evidence-based care."
        keywords="Shaquita Starks, psychiatric nurse practitioner, PMHNP-BC, FAAN, mental health provider"
      />

      <section className="py-16 bg-gradient-to-b from-[#f7f4f0] to-[#FDFDFB]">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <Card className="p-12 bg-white border-[#d4cec5] mb-12">
              <div className="md:flex items-start gap-8">
                <div className="flex-shrink-0 mb-6 md:mb-0">
                  <img
                    src="https://customer-assets.emergentagent.com/job_harmony-behavioral/artifacts/0xv7f47s_starks_shaquita_default_circle_crop_-_street_headshot.jpeg"
                    alt="Dr. Shaquita Starks"
                    className="w-64 h-64 rounded-lg object-cover shadow-lg mx-auto"
                  />
                </div>
                <div className="flex-1">
                  <h1 className="text-4xl font-bold text-[#7a8a72] mb-3">
                    Shaquita Starks, PhD, PMHNP-BC, FAAN
                  </h1>
                  <p className="text-xl text-[#7a8a72] font-semibold mb-6">
                    Board-Certified Psychiatric Mental Health Nurse Practitioner
                  </p>
                  <p className="text-[#3a3a3a] leading-relaxed mb-4">
                    Dedicated to providing high-quality, evidence-informed care Ms. Starks specializes in comprehensive psychiatric health for patients across the life-span (ages 5 and up in MD, DC and TN only).
                  </p>
                  <p className="text-[#3a3a3a] leading-relaxed mb-4">
                    Nursing professional since 1998, Ms. Starks brings extensive clinical expertise and has published extensively in areas of mental health. With an extensive clinical background and a commitment to clinical excellence, Ms. Starks focuses on personalized treatment plans that empower individuals to achieve mental wellness and functional balance.
                  </p>
                  <p className="text-[#3a3a3a] leading-relaxed mb-4">
                    Trained in Ketamine Assisted Psychotherapy and University Psychedelic Education Program Faculty Fellow, Ms. Starks integrates the latest clinical research with a patient-centered approach, offering a supportive environment for managing complex behavioral health needs.
                  </p>
                  <a
                    href="https://scholar.google.com/citations?user=pUOxWHYAAAAJ&hl=en"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-[#7a8a72] hover:text-[#6a7a62] font-semibold"
                  >
                    View Publications →
                  </a>
                </div>
              </div>
            </Card>

            <div className="grid md:grid-cols-2 gap-6 mb-12">
              <Card className="p-6 bg-[#a8b5a0] border-[#d4cec5]">
                <GraduationCap className="text-[#7a8a72] mb-4" size={40} />
                <h3 className="text-xl font-bold text-[#3a3a3a] mb-2">Education & Training</h3>
                <p className="text-[#3a3a3a]">PhD in Nursing Science, Post-Master's PMHNP, MSN, FNP, BSN</p>
              </Card>
              <Card className="p-6 bg-[#a8b5a0] border-[#d4cec5]">
                <Award className="text-[#7a8a72] mb-4" size={40} />
                <h3 className="text-xl font-bold text-[#3a3a3a] mb-2">Board Certifications</h3>
                <p className="text-[#3a3a3a]">Psychiatric Mental Health Nurse Practitioner, Fellow of the American Academy of Nursing</p>
              </Card>
              <Card className="p-6 bg-[#a8b5a0] border-[#d4cec5]">
                <Users className="text-[#7a8a72] mb-4" size={40} />
                <h3 className="text-xl font-bold text-[#3a3a3a] mb-2">Patient Focus</h3>
                <p className="text-[#3a3a3a]">Comprehensive psychiatric care for ages 5 and up across TN, GA, MD, and DC</p>
              </Card>
              <Card className="p-6 bg-[#a8b5a0] border-[#d4cec5]">
                <Heart className="text-[#7a8a72] mb-4" size={40} />
                <h3 className="text-xl font-bold text-[#3a3a3a] mb-2">Treatment Philosophy</h3>
                <p className="text-[#3a3a3a]">Evidence-based, patient-centered care focusing on whole-person wellness</p>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;